<script>
import { mapState, mapActions } from 'vuex'

export default {
  watch: {
    'toast.show': function(val, oldVal) {
      if (val && !oldVal) {
        this.$snotify.success(this.toast.msg)
        this.hideToast()
      }
    }
  },
  computed: mapState(['toast']),
  methods: {
    ...mapActions(['hideToast'])
  }
}
</script>
